import { Flex } from 'antd';

import { $Color, Color } from '@suntex.core/color';
import { Entities_Modules_Module } from '@suntex.fim/api-client';
import { FavoriteGamesAction } from '@suntex.fim/enums';
import { StarValue, StrictNodeModel } from '@suntex.fim/hub';

import { ComingSoon } from '../ComingSoon';
import { FavoriteButton } from '../FavoriteButton';
import { ModuleIcon } from '../ModuleIcon';
import { ProgressStar } from '../ProgressStar';

import { ContentModuleActions } from './ContentModuleActions';

export interface ContentModuleCardProps {
  module: Entities_Modules_Module;
  node: StrictNodeModel;
  categoryColor: Color;
  isFavorite: boolean;
  starValue: StarValue;
  underConstruction?: boolean;
  onToggleFavorite: (
    slug: string,
    variant: number | undefined,
    action: FavoriteGamesAction.Add | FavoriteGamesAction.Remove,
  ) => void;
}

export function ContentModuleCard({
  module,
  node,
  categoryColor,
  isFavorite,
  starValue,
  underConstruction,
  onToggleFavorite,
}: ContentModuleCardProps) {
  const slug = module.slug;
  const variant = node.moduleVariant;
  const action = isFavorite
    ? FavoriteGamesAction.Remove
    : FavoriteGamesAction.Add;
  const href = module.slugLink.urlNew.url;

  return (
    <div
      className="content-card"
      style={{
        borderTop: `4px solid ${$Color.toHexString(categoryColor)}`,
      }}
    >
      <Flex vertical gap={8} style={{ height: '100%' }}>
        <div className="content-card__title">
          <Flex align="center" justify="center" gap={8}>
            <ModuleIcon node={node} size="lg" />
            {/**
             * `module.description` actually represents the full name of the module,
             * outside the context of the hierarchy (i.e. "Skill Sets: Level 1 - Game 1" vs. "Game 1")
             */}
            <span>{module.description || module.name}</span>
          </Flex>
          <Flex align="center">
            <ProgressStar star={starValue} />
          </Flex>
        </div>

        <Flex
          align="center"
          justify="space-between"
          style={{ marginTop: 'auto' }}
        >
          {underConstruction ? (
            <ComingSoon />
          ) : (
            href && <ContentModuleActions href={href} />
          )}
          <FavoriteButton
            size="large"
            active={isFavorite}
            onClick={() => onToggleFavorite(slug, variant, action)}
          />
        </Flex>
      </Flex>
    </div>
  );
}
